import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MoneyOffCsredIcon(props: IconProps) {
    return <Icon {...props} iconKey={"money_off_csred"}/>
}
